import {Component} from 'react';
import PropTypes from 'prop-types';
import RCSlider from 'rc-slider';
import {range} from 'lodash';
import './Slider.scss';

const Range = RCSlider.Range;

class Slider extends Component {
  static propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
    value: PropTypes.string,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    min: 0,
    max: 0,
  };

  constructor(props) {
    super(props);
    const rangeValues = this.rangeValues();
    this.state = {
      trackworkStart: props.min,
      trackworkEnd: props.min,
      rangeStart: rangeValues[0],
      rangeEnd: rangeValues[1],
      prevStart: rangeValues[0],
      prevEnd: rangeValues[1],
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      const rangeValues = this.rangeValues();
      this.setState({
        rangeStart: rangeValues[0],
        rangeEnd: rangeValues[1],
      });
    }
  }

  rangeValues = () => {
    const {min, max, value} = this.props;
    if (value) {
      const values = value.split('-');
      if (values[1]) {
        return [values[0], values[1]].map((i) => parseInt(i, 10));
      }
      else if (values.length === 2) {
        return [values[0], max].map((i) => parseInt(i, 10));
      }
      else {
        return [values[0], values[0]].map((i) => parseInt(i, 10));
      }
    } else {
      return [min, max];
    }
  };

  trackworkStyle = () => {
    const {min, max} = this.props;
    const {trackworkStart, trackworkEnd} = this.state;
    if (trackworkStart === trackworkEnd) {
      return {
        display: 'none',
      };
    } else {
      const offsetCalc = (num) => (100/(max - min)) * num;
      return {
        left: `${offsetCalc(trackworkStart)}%`,
        width: `calc(${offsetCalc(trackworkEnd - trackworkStart)}% + 34px)`,
      };
    }
  };

  labelledHandle = (handleProps) => {
    const { value, dragging, max, index, ...restProps } = handleProps;
    const label = value === max ? `${value}+` : value.toString();
    return (
      <RCSlider.Handle key={index} value={value} {...restProps}>
        <span className="label">{label}</span>
      </RCSlider.Handle>
    );
  };

  dotHandles = (min, max) => {
    return range(min, max + 1).map((i, idx) => {
      const dot = this.labelledHandle({
        index: i,
        value: i,
        max,
        className: 'dot',
      });
      return (
        <div className="dot-wrapper"
             key={idx}
             style={{
               left: `calc(((100% + 48px) / ${max + 1}) * ${idx} - 7px)`,
               width: `calc((100% + 48px) / ${(max + 1)})`,
             }}
             onClick={this.handleDotClick(i)}
             onMouseDown={() => this.setState({down: true})}
             onMouseUp={() => this.setState({down: false})}
             onMouseEnter={this.handleDotEnter(i)}
             onMouseLeave={this.handleDotLeave}
         >
          {dot}
        </div>
      );
    });
  };

  handleDotClick = (i) => {
    return (e) => {
      const {rangeStart, rangeEnd, prevStart, prevEnd} = this.state;
      if (i >= prevStart && i <= prevEnd) {
        if (prevStart === prevEnd) {
          const {max} = this.props;
          this.setState({
            rangeStart: i,
            rangeEnd: max,
            prevStart: i,
            prevEnd: max,
          });
          this.notifyOnChange([i, max]);
        } else {
          this.setState({
            rangeStart: i,
            rangeEnd: i,
            prevStart: i,
            prevEnd: i,
          });
          this.notifyOnChange([i, i]);
        }
      } else {
        this.setState({
          prevStart: rangeStart,
          prevEnd: rangeEnd,
        });
      }
      this.handleDotLeave();
    };
  };

  handleDotEnter = (i) => {
    return (e) => {
      const {rangeStart, rangeEnd, down} = this.state;
      if (!down) {
        if (i < rangeStart) {
          this.setState({
            trackworkStart: i,
            trackworkEnd: rangeStart,
          });
        } else if (i > rangeEnd) {
          this.setState({
            trackworkStart: rangeEnd,
            trackworkEnd: i,
          });
        }
      }
    };
  };

  handleDotLeave = () => {
    this.setState({
      trackworkStart: 0,
      trackworkEnd: 0,
    });
  };

  notifyOnChange = (indexes) => {
    const {max, onChange} = this.props;
    if (indexes[1] === max) {
      onChange(`${indexes[0]}-`);
    }
    else if (indexes[0] !== indexes[1]) {
      onChange(`${indexes[0]}-${indexes[1]}`);
    }
    else {
      onChange(`${indexes[0]}`);
    }
  };

  handleRangeChange = (indexes) => {
    this.setState({
      rangeStart: indexes[0],
      rangeEnd: indexes[1],
      prevStart: this.state.rangeStart,
      prevEnd: this.state.rangeEnd,
    });
    this.notifyOnChange(indexes);
  };

  render() {
    const {className, label, min, max} = this.props;
    const {rangeStart, rangeEnd} = this.state;
    const trackStyle = this.trackworkStyle();
    return (
      <div className={`slider${className ? ' ' + className : ''}`}>
        {label && <span className="label">{label}</span>}
        <Range min={min}
               max={max}
               value={[rangeStart, rangeEnd]}
               handle={this.labelledHandle}
               onChange={this.handleRangeChange}
        >
          {this.dotHandles(min, max)}
          <div className="trackwork" style={trackStyle}/>
        </Range>
      </div>
    );
  }
}

export default Slider;
